export default {
  '新增场景成功':'New scenario added successfully',
  '关联设备成功':'Devices associated successfully',
  '编辑场景成功':'Scenario edited successfully',
  '设备名，SN号':'Device name, SN number',
  '保存并关闭':'Save and close',
  'SN码':'SN code',
  'MAC码':'MAC code',
  '设备列表':'Device list',
  '设备名、SN码、MAC码':'Device name, SN code, MAC code',
  '添加设备':'Add device',
  '已选中{num}人':'{num} people have been selected',
  '是否确认批量移除{num}个设备？':'Are you sure you want to batch remove {num} devices?',
  '是否确认移除设备{name}？':'Are you sure you want to remove the device {name}?',
  '场所列表':'Venue list',
  '场所名':'Venue name',
  '关联设备':'Associate devices',
  '场所名称':'Venue name',
  '场所类型':'Venue type',
  '场所ID':'Venue ID',
  '请输入两位数字ID':'Please enter a two-digit ID',
  '编辑场所':'Edit venue',
  '新增场所':'Add new venue',
  '确认要删除该场所吗？':'Are you sure you want to delete this venue?',
  '场所删除成功！':'Venue deleted successfully!',
}    